import "loading-attribute-polyfill"
import { initializeZoom, resetZoom } from "../new_player/player-zoom"
import { initializeNavigation, scrollToSlide } from "../new_player/player-navigation"
import { initializeSlideshowEvents } from "../tracking/amplitude/log-slideshow-events"
import { initializeProgressBar } from "../new_player/progress-bar"
import { sizePlayer } from "../new_player/dimensions"
import store, { initializeStore } from "../new_player/player-store"
import { initializeFilmstrip } from "../new_player/filmstrip"
import { initializeFullscreen } from "../new_player/fullscreen"
import { hideEndDisplay, initializeEndDisplay } from "../new_player/end-display"
import { hideShareScreen, initializeSharing } from "../new_player/share"
import { initializeClipping } from "../new_player/clipping"

const config = slideshare_object.slideshow_config

const registerListeners = () => {
  window.addEventListener("resize", () => {
    resetZoom()
    hideEndDisplay()
    hideShareScreen()
    sizePlayer()
    scrollToSlide(store.index)
  })
}

const initializeDependencies = () => {
  initializeSlideshowEvents()
  initializeNavigation()
  initializeProgressBar()
  initializeFilmstrip()
  initializeZoom()
  initializeFullscreen()
  initializeEndDisplay(config)
  initializeClipping()
  initializeSharing(config)
}

const initializePlayer = () => {
  initializeStore(config)
  sizePlayer()
  initializeDependencies()
  registerListeners()
}

initializePlayer()
